import { passwordSettingsApi } from '../../api/passwordSettingsApi.js'

import { addNotification } from './notificationActions.js'

import { passwordSettingsSignal, passwordSettingsErrorSignal, passwordSettingsLoadedSignal } from '../signals/passwordSettingsSignals.js'

export const fetchPasswordSettings = async (beId, config, accessToken) => {
	passwordSettingsLoadedSignal.value = false
	passwordSettingsSignal.value = []
	return await passwordSettingsApi.fetchPasswordSettings(beId, config, accessToken).then(
		(passwordSettings) => {
			passwordSettingsSignal.value = passwordSettings
			passwordSettingsLoadedSignal.value = true
			return passwordSettingsSignal.value
		}
	).catch(
		(err) => {
			passwordSettingsErrorSignal.value = err
			console.log(err)
			addNotification(`Unable to load password settings due to the following error: "${err}"`)
		}
	)
}